(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire402e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire402e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cJ15M", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && "object" === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ("number" === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && "object" === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === "string") {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === "number") return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "shift": 16,
    "ctrl": 17,
    "alt": 18,
    "pause/break": 19,
    "caps lock": 20,
    "esc": 27,
    "space": 32,
    "page up": 33,
    "page down": 34,
    "end": 35,
    "home": 36,
    "left": 37,
    "up": 38,
    "right": 39,
    "down": 40,
    "insert": 45,
    "delete": 46,
    "command": 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    "windows": 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    "ctl": 17,
    "control": 17,
    "option": 18,
    "pause": 19,
    "break": 19,
    "caps": 20,
    "return": 13,
    "escape": 27,
    "spc": 32,
    "spacebar": 32,
    "pgup": 33,
    "pgdn": 34,
    "ins": 45,
    "del": 46,
    "cmd": 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes["f" + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes["numpad " + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

function $fd79f639a2cdb34c$export$2e2bcd8739ae039(d) {
    let config = {
        kitId: "xai2hyg",
        scriptTimeout: 3000,
        async: false
    };
    let h = d.documentElement, t = setTimeout(function() {
        h.className = h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive";
    }, config.scriptTimeout), tk = d.createElement("script"), f = false, s = d.getElementsByTagName("script")[0], a;
    h.className += " wf-loading";
    tk.src = "https://use.typekit.net/" + config.kitId + ".js";
    tk.async = true;
    tk.onload = tk.onreadystatechange = function() {
        a = this.readyState;
        if (f || a && a != "complete" && a != "loaded") return;
        f = true;
        clearTimeout(t);
        try {
            Typekit.load(config);
        } catch (e) {}
    };
    s.parentNode.insertBefore(tk, s);
}



function $2fc8dae90286fb92$export$2e2bcd8739ae039(func, wait, immediate) {
    let timeout;
    return ()=>{
        const context = this, args = arguments;
        const later = ()=>{
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}



var $cJ15M = parcelRequire("cJ15M");
let $db0c1ec8880036b6$var$currentKeys = "";
let $db0c1ec8880036b6$var$combinations = [];
let $db0c1ec8880036b6$var$monitorKeys = false;
function $db0c1ec8880036b6$var$testCombinations() {
    const matches = $db0c1ec8880036b6$var$combinations.filter((comb)=>$db0c1ec8880036b6$var$currentKeys == comb.keys);
    console.log(matches);
    matches.forEach((match)=>match.action());
    $db0c1ec8880036b6$var$currentKeys = "";
}
const $db0c1ec8880036b6$var$debouncedTest = (0, $2fc8dae90286fb92$export$2e2bcd8739ae039)($db0c1ec8880036b6$var$testCombinations, 250);
document.onkeydown = (e)=>{
    const target = (0, (/*@__PURE__*/$parcel$interopDefault($cJ15M)))(e);
    if (target === "s") {
        $db0c1ec8880036b6$var$monitorKeys = true;
        return;
    }
    if ($db0c1ec8880036b6$var$monitorKeys) $db0c1ec8880036b6$var$currentKeys += target;
    $db0c1ec8880036b6$var$debouncedTest();
};
document.onkeyup = (e)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cJ15M)))(e) === "s") $db0c1ec8880036b6$var$monitorKeys = false;
};
function $db0c1ec8880036b6$export$2e2bcd8739ae039(keys, action) {
    $db0c1ec8880036b6$var$combinations = $db0c1ec8880036b6$var$combinations.filter((comb)=>comb.keys !== keys);
    $db0c1ec8880036b6$var$combinations.push({
        keys: keys,
        action: action
    });
}


let $b8f9b7833fa37166$var$colorClasses = [
    "base-pink",
    "base-green",
    "base-blue",
    "pink",
    "blue",
    "green",
    "light-pink",
    "light-blue",
    "light-pink-blue",
    "light-blue-pink",
    "dark-pink-blue",
    "dark-blue-pink",
    "dark-blue-green",
    "dark-pink-green",
    "dark-green-blue",
    "dark-green-pink"
];
(0, $fd79f639a2cdb34c$export$2e2bcd8739ae039)(document);
let $b8f9b7833fa37166$var$colorTimeout;
let $b8f9b7833fa37166$var$lastClass = "no-color";
function $b8f9b7833fa37166$var$pickColor(cancelColor = "no-color") {
    let color = $b8f9b7833fa37166$var$colorClasses[Math.floor(Math.random() * $b8f9b7833fa37166$var$colorClasses.length)];
    $b8f9b7833fa37166$var$switchColor(color, cancelColor);
    $b8f9b7833fa37166$var$colorTimeout = setTimeout(()=>$b8f9b7833fa37166$var$pickColor(color), 30000);
}
function $b8f9b7833fa37166$var$switchColor(newClass, oldClass) {
    document.body.classList.remove(oldClass);
    document.body.classList.add(newClass);
    $b8f9b7833fa37166$var$lastClass = newClass;
}
$b8f9b7833fa37166$var$pickColor();
$b8f9b7833fa37166$var$colorClasses.forEach((color, index)=>{
    (0, $db0c1ec8880036b6$export$2e2bcd8739ae039)((index + 1).toString(), ()=>{
        clearTimeout($b8f9b7833fa37166$var$colorTimeout);
        $b8f9b7833fa37166$var$switchColor(color, $b8f9b7833fa37166$var$lastClass);
    });
});

})();
//# sourceMappingURL=index.4c670bf3.js.map
